import type { VueUiTheme } from "@lunagoai/vue-ui";

export const posnextVueUiTheme: VueUiTheme = {
  light: {
    primary: "#087f98",
    primaryLight: "#22d3ee",
    primaryHover: "#006f87",
    primary50: "#ecfeff",
    primary100: "#cffafe",
    primary200: "#a5f3fc",
    primary500: "#0891b2",
    surface: "#ffffff",
    surfaceMuted: "#f8fafc",
    surfaceElevated: "#ffffff",
    text: "#0f172a",
    textMuted: "#64748b",
    textDim: "#94a3b8",
    border: "#dbe4ee",
    borderStrong: "#cbd5e1",
    focus: "#22d3ee",
    success: "#047857",
    warning: "#d97706",
    danger: "#be123c",
  },
  dark: {
    primary: "#0f8ba5",
    primaryLight: "#67e8f9",
    primaryHover: "#0b7288",
    primary500: "#22d3ee",
    surface: "#0f172a",
    surfaceMuted: "#111c30",
    surfaceElevated: "#172338",
    text: "#f8fafc",
    textMuted: "#94a3b8",
    textDim: "#64748b",
    border: "#26364d",
    borderStrong: "#334155",
    focus: "#22d3ee",
    success: "#34d399",
    warning: "#fbbf24",
    danger: "#fb7185",
    dark100: "#0f172a",
    dark200: "#26364d",
    darkText: "#f8fafc",
    darkTextMuted: "#94a3b8",
    darkTextDim: "#64748b",
  },
};
